export default function Progress(): object {
  const rootStyle = () => {
    const defaultStyle = {
      borderRadius: 4,
      height: '10px',
      border: 'none !important',
      // transform: 'rotate(180deg)',
      '& .MuiLinearProgress-bar': {
        borderRadius: 4,
      },
    };

    return [defaultStyle];
  };

  return {
    MuiLinearProgress: {
      styleOverrides: {
        root: () => rootStyle(),
      },
    },
  };
}
